(function () {
  if (window.LWGSizeSelect) return;
  var SKIP = 'product-card, quick-add-dialog, dialog, product-recommendations';
  var STRIKE =
    '<svg viewBox="0 0 100 46" preserveAspectRatio="xMidYMid slice" class="variant-option__strikethrough" aria-hidden="true">' +
    '<line x1="100" y1="0" x2="0" y2="46" vector-effect="non-scaling-stroke"/><line x1="100" y1="0" x2="0" y2="46" vector-effect="non-scaling-stroke"/></svg>';
  var eventsP = null;
  function events() {
    if (!eventsP) {
      try {
        eventsP = import('@shopify/events');
      } catch (err) {
        eventsP = Promise.reject(err);
      }
    }
    return eventsP;
  }
  function setAttr(el, n, v) {
    if (el.getAttribute(n) !== v) el.setAttribute(n, v);
  }
  function optName(fs) {
    var inp = fs.querySelector('input[data-option-name]');
    return inp ? inp.getAttribute('data-option-name') : null;
  }
  function position(inp) {
    return parseInt(String(inp.getAttribute('data-input-id') || '').split('-')[0], 10);
  }
  function variantsOf(picker) {
    try {
      return JSON.parse(picker.getAttribute('data-lwg-variants') || '[]');
    } catch (err) {
      return [];
    }
  }
  function setButtonText(btn, text) {
    for (var n = btn.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3 && n.data.trim()) {
        if (n.data.trim() !== text) n.data = text;
        return;
      }
    }
  }

  function attach(picker, o) {
    var keep = o.keep || [];
    var pending = (picker.getAttribute('data-lwg-size-options') || '').split('|').filter(function (n) {
      return n && keep.indexOf(n) === -1;
    });
    if (!pending.length) return null;
    var scope = o.scope;
    var inDialog = !!o.dialog;
    var variants = variantsOf(picker);
    var finalizing = false;
    var hooked = false;
    var dead = false;
    var picks = {};
    if (!inDialog) document.documentElement.classList.add('lwg-size-pending');

    var status = document.createElement('p');
    status.className = 'visually-hidden lwg-size-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    picker.insertAdjacentElement('afterend', status);
    function say(t) {
      if (status.textContent !== t) status.textContent = t;
    }
    function label() {
      return 'Select a ' + String(pending[0] || 'size').toLowerCase();
    }
    function own(el) {
      return scope.contains(el) && (inDialog || !el.closest(SKIP));
    }
    function mine(sel) {
      return Array.prototype.filter.call(scope.querySelectorAll(sel), own);
    }

    function enforceAvailability() {
      if (!variants.length) return;
      var fieldsets = picker.querySelectorAll('fieldset.variant-option');
      var confirmed = {};
      for (var f = 0; f < fieldsets.length; f++) {
        if (pending.indexOf(optName(fieldsets[f])) !== -1) continue;
        var c = fieldsets[f].querySelector('input:checked');
        if (c) confirmed[position(c)] = c.value;
      }
      var inputs = picker.querySelectorAll('fieldset.variant-option input');
      for (var k = 0; k < inputs.length; k++) {
        var inp = inputs[k];
        var pos = position(inp);
        if (!pos) continue;
        var ok = false;
        for (var v = 0; v < variants.length && !ok; v++) {
          var opts = variants[v][1];
          if (!variants[v][2] || opts[pos - 1] !== inp.value) continue;
          ok = true;
          for (var q in confirmed) {
            if (+q !== pos && opts[q - 1] !== confirmed[q]) {
              ok = false;
              break;
            }
          }
        }
        setAttr(inp, 'data-option-available', ok ? 'true' : 'false');
        if (ok) inp.removeAttribute('aria-disabled');
        else setAttr(inp, 'aria-disabled', 'true');
        var lab = inp.closest('label');
        var svg = lab ? lab.querySelector('.variant-option__strikethrough') : null;
        if (ok && svg) svg.remove();
        if (!lab || lab.classList.contains('variant-option__button-label--has-swatch')) continue;
        if (!ok && !svg) lab.insertAdjacentHTML('beforeend', STRIKE);
        var tx = lab.querySelector('.variant-option__button-label__text');
        if (ok && tx && !lab.querySelector('.variant-option__button-label__pill')) {
          tx.insertAdjacentHTML('beforebegin', '<span class="variant-option__button-label__pill" data-key="variant-option-pill"></span>');
        }
      }
    }

    function enforcePicker() {
      var fieldsets = picker.querySelectorAll('fieldset.variant-option');
      for (var f = 0; f < fieldsets.length; f++) {
        var fs = fieldsets[f];
        var name = optName(fs);
        var legend = fs.querySelector('legend');
        var tip = legend ? legend.querySelector('.lwg-choose') : null;
        if (name && pending.indexOf(name) !== -1) {
          if (!fs.classList.contains('lwg-needs-choice')) fs.classList.add('lwg-needs-choice');
          var inputs = fs.querySelectorAll('input');
          for (var k = 0; k < inputs.length; k++) {
            if (inputs[k].checked) inputs[k].checked = false;
            if (inputs[k].hasAttribute('checked')) inputs[k].removeAttribute('checked');
            setAttr(inputs[k], 'data-current-checked', 'false');
            setAttr(inputs[k], 'data-previous-checked', 'false');
          }
          var text = 'Select a ' + name.toLowerCase();
          if (legend && !tip) {
            tip = document.createElement('span');
            tip.className = 'lwg-choose';
            legend.appendChild(tip);
          }
          if (tip && tip.textContent !== text) tip.textContent = text;
        } else {
          if (fs.classList.contains('lwg-needs-choice')) fs.classList.remove('lwg-needs-choice', 'lwg-flash');
          if (tip) tip.remove();
        }
      }
    }

    function enforceButtons() {
      var text = label();
      mine('product-form-component [ref="addToCartButton"]').forEach(function (b) {
        if (b.closest('sticky-add-to-cart')) return;
        if (!b.disabled) b.disabled = true;
        if (!b.classList.contains('lwg-pending-btn')) b.classList.add('lwg-pending-btn');
        setButtonText(b, text);
      });
      mine('product-form-component .accelerated-checkout-block').forEach(function (a) {
        if (!a.inert) a.inert = true;
        if (!a.classList.contains('lwg-pending-ac')) a.classList.add('lwg-pending-ac');
      });
      if (inDialog) return;
      var sticky = scope.querySelector('sticky-add-to-cart');
      if (!sticky) return;
      var sb = sticky.querySelector('[ref="addToCartButton"]');
      if (sb) {
        if (sb.disabled) sb.disabled = false;
        setAttr(sb, 'aria-disabled', 'true');
        if (!sb.classList.contains('lwg-pending-btn')) sb.classList.add('lwg-pending-btn');
        var st = sb.querySelector('.add-to-cart-text__content > span');
        if (st && st.textContent.trim() !== text) st.textContent = text;
      }
      var sv = sticky.querySelector('.sticky-add-to-cart__variant');
      if (sv && sv.textContent.trim() !== text) sv.textContent = text;
    }

    function finalize() {
      if (pending.length || dead) return;
      if (!inDialog) document.documentElement.classList.remove('lwg-size-pending');
      scope.querySelectorAll('.lwg-pending-btn').forEach(function (b) {
        if (!own(b)) return;
        b.classList.remove('lwg-pending-btn');
        if (b.closest('sticky-add-to-cart')) b.removeAttribute('aria-disabled');
      });
      mine('product-form-component .accelerated-checkout-block').forEach(function (a) {
        a.inert = false;
        a.classList.remove('lwg-pending-ac');
      });
      stop();
    }

    function enforceLinks() {
      if (!inDialog || !pending.length) return;
      var links = scope.querySelectorAll('a[href*="variant="]');
      for (var i = 0; i < links.length; i++) {
        try {
          var u = new URL(links[i].getAttribute('href'), window.location.href);
          if (u.pathname.indexOf('/products/') === -1 || !u.searchParams.has('variant')) continue;
          u.searchParams.delete('variant');
          setAttr(links[i], 'href', u.origin === window.location.origin ? u.pathname + u.search + u.hash : u.href);
        } catch (err) {}
      }
    }

    function enforce() {
      if (dead) return;
      enforcePicker();
      if (pending.length) {
        enforceAvailability();
        enforceButtons();
        enforceLinks();
      }
    }

    function goToPicker() {
      var target = picker.querySelector('fieldset.lwg-needs-choice') || picker;
      target.scrollIntoView({ behavior: document.visibilityState === 'visible' ? 'smooth' : 'instant', block: 'center' });
      target.classList.add('lwg-flash');
      setTimeout(function () {
        target.classList.remove('lwg-flash');
      }, 1600);
      var first = target.querySelector('input:not([aria-disabled="true"])');
      if (first && first.focus) first.focus({ preventScroll: true });
      say('');
      setTimeout(function () {
        if (pending.length) say(label());
      }, 60);
    }

    function onChange(e) {
      var t = e.target;
      var name = t && t.getAttribute ? t.getAttribute('data-option-name') : null;
      if (name) picks[name] = t.value;
      var idx = name ? pending.indexOf(name) : -1;
      if (idx === -1) return;
      pending.splice(idx, 1);
      if (pending.length) {
        say(name + ' ' + t.value + ' selected. ' + label());
        return;
      }
      var parts = [];
      for (var n in picks) parts.push(n + ' ' + picks[n]);
      say(parts.join(', ') + ' selected');
      finalizing = true;
      if (!hooked) setTimeout(finalize, 3000);
    }

    var BTN =
      'sticky-add-to-cart [ref="addToCartButton"], product-form-component [ref="addToCartButton"], product-form-component .accelerated-checkout-block';
    function onClick(e) {
      if (!pending.length || !e.target || !e.target.closest) return;
      var hit = e.target.closest(BTN);
      if (!hit || !own(hit)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      goToPicker();
    }
    function onSubmit(e) {
      if (!pending.length || !e.target || !e.target.closest) return;
      var form = e.target.closest('product-form-component');
      if (!form || !own(form)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      goToPicker();
    }
    var target = inDialog ? scope : window;
    picker.addEventListener('change', onChange, true);
    target.addEventListener('click', onClick, true);
    target.addEventListener('submit', onSubmit, true);

    var observer = new MutationObserver(enforce);
    observer.observe(scope, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['checked', 'disabled', 'data-current-checked', 'data-option-available', 'hidden', 'aria-disabled', 'href'],
    });

    var evName = null;
    function onSelect(e) {
      if (!e || !e.promise || !e.promise.then || !own(e.target)) return;
      e.promise.then(
        function () {
          setTimeout(function () {
            if (finalizing) finalize();
            else enforce();
          }, 0);
        },
        function () {}
      );
    }
    events()
      .then(function (m) {
        evName = m && m.StandardEvents && m.StandardEvents.productSelect;
        if (!evName || dead) return;
        hooked = true;
        scope.addEventListener(evName, onSelect);
      })
      .catch(function () {});

    function stop() {
      observer.disconnect();
      picker.removeEventListener('change', onChange, true);
      target.removeEventListener('click', onClick, true);
      target.removeEventListener('submit', onSubmit, true);
      if (evName) scope.removeEventListener(evName, onSelect);
    }

    say(label());
    enforce();
    if (!inDialog) document.addEventListener('DOMContentLoaded', enforce);
    return {
      destroy: function () {
        stop();
        dead = true;
        if (status.parentNode) status.remove();
      },
    };
  }

  function handle(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
  function filterKeeps(picker, linked) {
    var out = [];
    var ref;
    try {
      ref = new URL(document.referrer);
    } catch (err) {
      return out;
    }
    if (ref.origin !== window.location.origin) return out;
    var fieldsets = picker.querySelectorAll('fieldset.variant-option');
    for (var f = 0; f < fieldsets.length; f++) {
      var inp = fieldsets[f].querySelector('input[data-option-name]');
      if (!inp) continue;
      var name = inp.getAttribute('data-option-name');
      var pos = position(inp);
      var val = pos ? String(linked[1][pos - 1] || '').toLowerCase() : '';
      var wanted = ref.searchParams.getAll('filter.v.option.' + handle(name)).map(function (x) {
        return String(x).toLowerCase();
      });
      if (val && wanted.indexOf(val) !== -1) out.push(name);
    }
    return out;
  }

  function main() {
    if (window.__lwgSizeSelect) return;
    var pickers = document.querySelectorAll('variant-picker[data-lwg-size-options][data-template-product-match="true"]');
    var picker = null;
    for (var i = 0; i < pickers.length && !picker; i++) {
      if (!pickers[i].closest(SKIP)) picker = pickers[i];
    }
    if (!picker) return;
    window.__lwgSizeSelect = true;
    var params = new URLSearchParams(window.location.search);
    var vid = (params.get('variant') || '').trim();
    var list = variantsOf(picker);
    var linked = null;
    for (var v = 0; v < list.length && !linked; v++) {
      if (vid && String(list[v][0]) === vid) linked = list[v];
    }
    var themeLink = /[?&](_pos|_fid|_ss|_sid|_psq)=/.test(window.location.search);
    if (linked && !themeLink) return;
    var keep = linked ? filterKeeps(picker, linked) : [];
    var ov = (params.get('option_values') || '').split(',');
    picker.querySelectorAll('input[data-option-value-id]').forEach(function (inp) {
      if (ov.indexOf(inp.getAttribute('data-option-value-id')) !== -1) keep.push(inp.getAttribute('data-option-name'));
    });
    attach(picker, { scope: picker.closest('.shopify-section') || document.body, keep: keep });
  }

  var dialogCtl = null;
  function dialog(root) {
    if (dialogCtl) dialogCtl.destroy();
    dialogCtl = null;
    if (!root) return;
    var picker = root.querySelector('variant-picker[data-lwg-size-options]');
    if (picker) dialogCtl = attach(picker, { scope: root, dialog: true });
  }

  window.LWGSizeSelect = { main: main, dialog: dialog };
})();
